import './B2BPopUpForm.css';

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import CustomButton from './CustomButton';
import { generateClassName } from './helpers';


const B2BPopUpForm = ({ open, icon = null, title, sectionTitle = null, children, buttons, onClose, className }) => {
    
    const [currentOpen, setCurrentOpen] = useState(open);

    useEffect(() => {
        if (open !== currentOpen)
            setCurrentOpen(open);
    }, [open]);

    const handleClose = (event) => {
        setCurrentOpen(false);
        onClose && onClose(event);
    }

    return (
        <Modal
            open={currentOpen ? currentOpen : false}
            onClose={handleClose}
            aria-labelledby="b2b-pop-up-form-modal-title"
            aria-describedby="b2b-pop-up-form-modal-description"
            className={generateClassName('b2b-popup', '-modal', className)}
        >
            <Box className={generateClassName('b2b-popup', '-box', className)}>
                <div className={generateClassName('b2b-popup', '-header', className)}>
                    <div className={generateClassName('b2b-popup', '-icon-description', className)}>
                        {icon}
                        {sectionTitle && (
                            <div className={generateClassName('b2b-popup', '-section-title', className)}>
                                {sectionTitle}
                            </div>
                        )}
                        <div className={generateClassName('b2b-popup', '-title', className)}>
                            {title}
                        </div>
                    </div>
                    <IconButton onClick={handleClose} color="primary" className={generateClassName('b2b-popup', '-close-button', className)}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className={generateClassName('b2b-popup', '-content', className)}>
                    {children}
                </div>
                {buttons && (
                    <div className={generateClassName('b2b-popup', '-buttons', className)}>
                        {buttons.map((button, index) => (
                            <CustomButton key={index} {...button}>
                                {button.label}
                            </CustomButton>
                        ))}
                    </div>
                )}
            </Box>
        </Modal>
    );
};

B2BPopUpForm.propTypes = {
    open: PropTypes.bool,
    icon: PropTypes.element,
    title: PropTypes.node.isRequired,
    buttons: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func,
    })),
    onClose: PropTypes.func.isRequired,
};

CustomButton.propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.element, // React element representing the icon
};

export default B2BPopUpForm;